<script setup lang="ts">
import { backgroundColorInjectKey } from "../helpers/injectKeys";
import type { BlokDates } from "@/.storyblok/types/120421/storyblok-components";

defineProps<{
  blok: BlokDates;
}>();

const injectedBackgroundColor = inject(
  backgroundColorInjectKey
) as BackgroundColorKey;
</script>

<template>
  <BaseContentSection
  v-editable="blok"
    :background-color="injectedBackgroundColor"
    class="relative xs:max-w-screen-xs sm:max-w-screen-sm mx-auto"
  >
    <div class="timeline-wrapper">
      <div
        class="timeline"
        :class="{
          'bg-brandDark': injectedBackgroundColor === 'light',
          'bg-brandLight':
            injectedBackgroundColor === 'dark' ||
            injectedBackgroundColor === 'medium',
        }"
      ></div>
      <div class="dates">
        <BlokDateEntry
          v-for="date of blok.dates"
          :key="date.dateStart"
          class="dates__entry"
          :blok="date"
        ></BlokDateEntry>
      </div>
    </div>
  </BaseContentSection>
</template>

<style lang="scss" scoped>
.timeline-wrapper {
  @screen sm {
    display: flex;
    justify-content: center;
  }
}
.timeline {
  width: 4px;
  height: 100%;
  position: absolute;
  transform: translateX(-50%);

  @screen sm {
    transform: none;
  }
}

.dates {
  padding-top: 32px;

  @screen sm {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__entry {
    padding-bottom: 32px;

    @screen sm {
      max-width: 50%;
    }
  }
}
</style>
